export default "__VITE_ASSET__f65ec029__"